import { render, staticRenderFns } from "./PrfResumeParihuela.vue?vue&type=template&id=0b8c8a3a"
import script from "./PrfResumeParihuela.vue?vue&type=script&lang=js"
export * from "./PrfResumeParihuela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports